import {Component} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {OrderService} from "../../order/order.service";
import {deliveryMethodValues, shippingDestinationValues} from "../../order/order-value-maps";
import {WorkflowStep} from "../workflow-step";
import {WorkflowStepStatus} from "../models/workflow-step-status.enum";
import {WorkflowService} from "../workflow.service";
import {DialogService} from "../../bootstrap-modal/dialog.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {OrderGqlModel} from "../../order/order.gql-model";
import {toggleLoading} from "../../misc/loading.decorator";

@Component({
  templateUrl: "./order-details.template.pug",
  providers: [
    OrderService,
    DialogService,
  ],
})
export class OrderDetails extends WorkflowStep {
  order: OrderGqlModel;
  error: Error;

  shippingDestinationValues: any = Object.keys(shippingDestinationValues)
    .map(k => ([k, shippingDestinationValues[k]]));

  deliveryMethodValues: any = Object.keys(deliveryMethodValues)
    .map(k => ([k, deliveryMethodValues[k]]));

  @toggleLoading()
  @handleErrors()
  async loadData(): Promise<void> {
    const {order} = await this.orderService.getOrderById(this.workflowService.workflowConfig.targetId);
    this.order = order;

    let doPatch = false;
    const patch = {};

    if (!this.order.shippingDestination) {
      doPatch = true;
      patch["shippingDestination"] = "CUSTOMER_SITE";
    }

    if (!this.order.deliveryMethod) {
      doPatch = true;
      patch["deliveryMethod"] = "STANDARD";
    }

    if (this.order.requestedDeliveryDate) {
      doPatch = true;
      patch["requestedDeliveryDatePicker"] = this.order.requestedDeliveryDate;
    }

    if (this.order.estimatedHardwareOrderDate) {
      doPatch = true;
      patch["estimatedHardwareOrderDatePicker"] = this.order.estimatedHardwareOrderDate;
    }

    if (doPatch) {
      this.order.form.patchValue(patch);
      this.order.form.markAsDirty();
    }
  }

  ready() {
    this.loadData();
  }

  constructor(
    private orderService: OrderService,
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public dialogService: DialogService,
  ) {
    super(true);
  }

  @handleErrors()
  async autoSave(): Promise<boolean> {
    await this.orderService.save(this.order);

    await this.workflowService.setStepStatus(WorkflowStepStatus.Completed);

    return true;
  }

  checkDirty(): boolean {
    return this.order.form.dirty;
  }

  public DPToTxt(param): void {
    const date = this.order.form.getRawValue()[`${param}Picker`];
    this.order.form.controls[param].setValue(date);
  }

  public txtToDP(param): void {
    let date = this.order.form.getRawValue()[param];
    if (date && date.trim() === "") {
      date = null; // Allow date to be cleared out, but pass any invalid dates through so that we yell at the user
    }
    this.order.form.controls[`${param}Picker`].setValue(date);
  }
}
